module.exports = __webpack_public_path__ + "static/media/preview.96f01f91.png";